import { create } from 'zustand';
import { Entry, Pick } from '../../interfaces/predictors';
import { deepCopy } from '../../common/objectUtils';
import { devTools } from '../../common/devtools';

export interface EntryStoreState {
  entry?: Entry;
  picks?: Pick[]; //this is the local changes to the entry
  playClicked: boolean;
  setEntry: (entry?: Entry) => void;
  setPlayClicked: (playClicked: boolean) => void;
  setPick: ({
    eventNumber,
    selectionCode,
    eventId,
    marketId,
  }: {
    eventNumber: number;
    selectionCode: number | string | undefined;
    eventId: number;
    marketId?: number;
  }) => void;
  reset: () => void;
}

const initialState = {
  entry: undefined,
  picks: undefined,
  playClicked: false,
};

export const useEntryStore = create<EntryStoreState>()((set) => ({
  ...initialState,
  //set entry should also set picks if defined
  setEntry: (entry) =>
    set((state) => {
      const picks = deepCopy(entry?.picks);
      //only update to the new picks if the entry.picks is valid
      return { entry, picks: picks ? picks : state.picks };
    }),
  setPlayClicked: (playClicked) => set(() => ({ playClicked })),
  setPick: ({ eventNumber, selectionCode, eventId, marketId }) =>
    set((state) => {
      devTools.log('setPick', { eventNumber, selectionCode, eventId });
      selectionCode = selectionCode !== undefined ? String(selectionCode) : selectionCode;
      //clone picks as we don't want to mess with the actual array
      const picks = state.picks ? deepCopy(state.picks) : [];

      // update the existing pick or create a new one
      const pick = picks?.find((pick) => pick.eventNumber === eventNumber);

      if (pick) pick.selectionCode = selectionCode;
      else
        picks.push({
          eventNumber,
          selectionCode,
          eventId,
          marketId,
          active: true,
        });
      //update the picks part of the store only
      return {
        picks: [...picks],
      };
    }),
  reset: () => {
    set(initialState);
  },
}));
